/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useSiteData } from "../context/SiteDataContext";

const ServiceDeRelecture = ({ isBg }) => {
  const { data } = useSiteData();
  const config = data?.serviceDeRelectureConfig || {};

  // Fallback to default values if config is not loaded
  const image = config.image || "assets/images/open_book.jpg";
  const title = config.title || "Service de relecture";
  const subtitle = config.subtitle || "Besoin d'une relecture professionnelle ?";
  const description = config.description || "Description du service de relecture...";

  return (
    <section
      id="service-relecture"
      className={`section-padding ${isBg === "yes" ? "bg-one" : ""}`}
      style={{ minHeight: "400px", padding: "80px 0" }}
    >
      <div className="container">
        <div className="row align-items-center">
          {/* Image à gauche */}
          <div
            className="col-lg-6"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div className="service-image">
              <img
                className="img-fluid"
                src={image}
                alt={title}
                onError={(e) => {
                  console.error("Image non trouvée:", e.target.src);
                  e.target.style.display = "none";
                }}
              />
            </div>
          </div>

          {/* Contenu à droite */}
          <div
            className="col-lg-6"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div className="service-content">
              <div className="section-title-left">
                <span>{title}</span>
                <h2 className="display-6">{subtitle}</h2>
                <div className="section-divider divider-traingle"></div>
              </div>

              <div
                className="mb-4"
                dangerouslySetInnerHTML={{ __html: description }}
              />

              <p className="mb-0">
                <a href="#contact" className="button button__primary">
                  <span>Demandez un devis</span>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceDeRelecture;
